import type { IAppEnvironment } from '@bp/shared/typings';

export const environment: Partial<IAppEnvironment> = {
	api: 'https://signup.bridgerpay.dev',
	oauthGoogleClientId: '329027545849-cpadb0dvcb1b2h5o65t7rstq9rt001r6.apps.googleusercontent.com',
};
